// Web-specific constants (Vite-dependent)

// API configuration
export const getApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  return import.meta.env.PROD ? '/api' : 'http://localhost:3001/api';
};
